import { render, staticRenderFns } from "./LongTailSearch.vue?vue&type=template&id=408fb898&scoped=true&"
import script from "./LongTailSearch.vue?vue&type=script&lang=js&"
export * from "./LongTailSearch.vue?vue&type=script&lang=js&"
import style0 from "./LongTailSearch.vue?vue&type=style&index=0&id=408fb898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fb898",
  null
  
)

export default component.exports